module.exports = __webpack_public_path__ + "static/img/m_name.9afba4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/bn/m_name.png
// module id = Ib2a
// module chunks = 7